// extracted by mini-css-extract-plugin
export var defaultWrapper = "_k1-3";
export var downloadButton = "_k1-4";
export var fileContainer = "_k1-9 _k1-7";
export var fileContainerBase = "_k1-7";
export var fileContainerBaseSm = "_k1-a _k1-7";
export var fileContainerFixedHeight = "_k1-8 _k1-7";
export var fileContainerFixedHeightSm = "_k1-c _k1-a _k1-7";
export var fileContainerSm = "_k1-b _k1-a _k1-7";
export var fileInfo = "_k1-5";
export var fileInfoWidthRestricted = "_k1-6";
export var fileType = "_k1-1";
export var fileTypeName = "_k1-2";
export var fileTypeSm = "_k1-d _k1-1";
export var image = "_k1-0";
export var link = "_k1-f";
export var overflowEllipsis = "_k1-e";